module.exports = __webpack_public_path__ + "static/img/cgal7.d509648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal7.png
// module id = eJ7G
// module chunks = 1